module.exports = __webpack_public_path__ + "img/img18.46718e7c.png";